<div class="container mt-2 pb-4">

  <div class="row">

    <div class="betting-category mb-2">
      <div class="card-body px-0">
        <div class="d-flex">
          <div class="race-icon bordered mr-2">
            <span class="icon icon-cricket" style="color: #000;"></span>
          </div>
          <div class="d-flex flex-column">
            <span class="t">{{kironResults[0]?.meetingName}}</span>
            <span class="t-faded t-medium"><strong>{{kironResultsMeetingCode}}</strong></span>
            <span class="t-faded t-smaller">{{kironResults[0]?.meetingDate}} {{kironResults[0]?.meetingTime}}</span>
          </div>
          <div class="extra d-flex">
            <div class="d-flex flex-column align-items-end mt-2" style="color: #2d3436;">
              <span class="t">{{'COMMON.RESULTS' | translate}} </span>

            </div>

            <a href="#" data-toggle="modal" data-target="#cricketSuperOverResultModal"
              class="btn btn-tertiary icon ml-2" (click)="get_kiron_results()">
              <span class="icon icon-menu"></span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div (click)="video_clicked()" class="live btn mb-2">{{'COMMON.WATCH-LIVE-STREAM' | translate}}</div>



    <div *ngIf="is_no_data">
      <div class="col-12 mb-3 p-1">
        <div class="card">
          <div class="card-body">
            <a class="t" style="font-size: medium;color: black;">{{'COMMON.MESSAGES.SPORT-NO-EVENT' | translate}}</a>
          </div>
        </div>
      </div>
    </div>

    <app-sport-details *ngIf="viewSelectionBlock == true" [selectedMeeting]="selectedMeeting"
      style="padding-left: 0;padding-right: 0;"></app-sport-details>

    <div class="container mt-2 pb-4" style="margin-bottom: 150px;" [hidden]="viewSelectionBlock">
      <div class="row" id="accordionExample">
        <div class="betting-category card-collapsible mb-2 px-0" id="dropdown" (click)="colorChange($event,i)"
          *ngFor="let odd of ODDs; let i=index">
          <div class="card-header px-2" id="scrollto{{i}}">
            <div (click)="getOddData(odd.id,i)" class="p-2 dropdown-toggle-chevron collapsed addpadding"
              data-toggle="collapse" [attr.data-target]="'#id' + i" aria-expanded="true" aria-controls="collapseOne">
              <div class="d-flex flex-column">
                <span class="t">{{odd.meetingName}} - {{cricketSuperResultMettingCode(odd.meetingCode)}} </span>
                <span class=" t-smaller">{{odd.meetingLocalTime}}</span>
              </div>
            </div>
            <div class="p-2 d-flex align-items-center" *ngIf="odd.matchWinner.length!=0">
              <div class="t-medium flex-fill text-black">{{matchWinner}}</div>

              <button *ngIf="odd.matchWinner[0] && odd.matchWinner[0].lastOddDec!=1"
                (click)="setSPOdd(odd.matchWinner[0])"
                [ngClass]="{'btn-tertiaryActive':odd.matchWinner[0].clicked == true, 'odds':odd.matchWinner[0].clicked != true}"
                class="btn btn-tertiary flex-fill ml-2 odds">
                <span class="secondary">{{odd.sel1Name}} <br>{{odd.matchWinner[0].lastOddDec}}</span>
              </button>
              <button *ngIf="odd.matchWinner[0] && odd.matchWinner[0].lastOddDec==1"
                [ngClass]="{'btn-tertiaryActive':odd.matchWinner[0].clicked == true, 'odds':odd.matchWinner[0].clicked != true}"
                class="btn btn-tertiary-red flex-fill ml-2 odds">
                <span class="secondary suspend">{{odd.sel1Name}} <br>{{'COMMON.SUSPEND' | translate}}</span>
              </button>

              <button *ngIf="odd.matchWinner[1] && odd.matchWinner[1].lastOddDec!=1"
                (click)="setSPOdd(odd.matchWinner[1])"
                [ngClass]="{'btn-tertiaryActive':odd.matchWinner[1].clicked == true, 'odds':odd.matchWinner[1].clicked != true}"
                class="btn btn-tertiary flex-fill ml-2">
                <span class="secondary">{{odd.sel2Name}} <br>{{odd.matchWinner[1].lastOddDec}}</span>
              </button>
              <button *ngIf="odd.matchWinner[1] && odd.matchWinner[1].lastOddDec==1"
                [ngClass]="{'btn-tertiaryActive':odd.matchWinner[1].clicked == true, 'odds':odd.matchWinner[1].clicked != true}"
                class="btn btn-tertiary-red flex-fill ml-2 odds">
                <span class="secondary suspend">{{odd.sel2Name}} <br>{{'COMMON.SUSPEND' | translate}}</span>
              </button>
            </div>
          </div>
          <div class="collapse" id="id{{i}}" data-parent="#accordionExample">
            <div *ngIf="isOddShown(odd.id)">
              <table class="table table-striped mb-0 border-top">
                <tbody>
                  <tr *ngFor="let oddEvents of odd.eventData; index as i" class="sub-item">
                    <td>
                      <div class="d-flex flex-column">
                        <span class="t">{{oddEvents.eventName}}</span>
                        <span class="t-faded t-smaller">{{oddEvents.eventLabel}}</span>
                      </div>
                    </td>
                    <td class="text-right">
                      <a (click)="viewSportDetails(oddEvents,$event)" class="btn btn-tertiary icon">
                        <span class="icon icon-arrow-right"></span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>





    <!-- Modal -->
    <div class="modal fade" id="cricketSuperOverResultModal" data-backdrop="false" tabindex="100000" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document" style="margin-left: 0px;margin-right: 0px;">
        <div class="modal-content" style="margin-top: 200px;margin-bottom: 100px;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{'COMMON.RESULTS' | translate}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span style="font-size: 35px;" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" id="accordionExample1">

            </div>
            <div class="race-preview shadow p-0 mb-2 card-collapsible" id="dropdownResult"
              *ngFor="let item of kironResults; let k=index" (click)="resultExplan($event,k)">
              <div id="scrollto{{k}}">
                <div class="race-header bg-fill-secondary text-white dropdown-toggle-chevron collapsed"
                  data-toggle="collapse" [attr.data-target]="'#id' + k" aria-expanded="true"
                  aria-controls="collapseOne">
                  <div class="race-info">
                    <div class="race-name text-uppercase">{{item.meetingName}}</div>
                    <div>{{cricketSuperResultMettingCode(item.meetingCode)}}</div>
                    <div class="race-description text-uppercase">{{item.meetingDate}} {{item.meetingTime}} (Local)
                    </div>
                    <div class="race-description text-uppercase">{{item.meetingDateUK}} {{item.meetingTimeUK}} (UK)
                    </div>


                  </div>
                  <div class="race-extra">
                    <!-- {{cricketSuperResultMettingCode(item.meetingCode)}} -->
                    <!-- <span class="secondary">{{item.eventTimeUTC.substr(0,10)}}</span> -->
                  </div>

                </div>
              </div>


              <div class="collapse" id="id{{k}}" data-parent="#accordionExample1">
                <div class="d-flex flex-column" *ngFor="let event of item.events index as i" style="padding: 5px;">
                  <div class="race-content" style="background-color: #d1d7db;  border: 1px solid #d1d7db;">
                    <span class="t" style="margin-left: 5px;">{{event.eventName}}</span>
                    <table class="racing-table table-striped">
                      <thead>
                        <tr>
                          <th style="padding: 0.25rem;" class="text-left">Selection</th>
                          <th style="padding: 0.25rem;" class="text-right">Win</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-left">{{event.eventPositions[0].selectionName}}</td>
                          <td class="text-right">{{event.eventPositions[0].winDisplayAmount}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>